import { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import Modal from "../../../../../../components/Modal";
import { Formik } from "formik";
import {
  Center,
  FlexContainer,
  Separator,
} from "../../../../../../components/StyledComponents";
import {
  initialValues,
  schema,
} from "../../../../../../constants/form/suscription/edit";
import Grid from "../../../../../../components/Grid";
import Button from "../../../../../../components/Button";
import Submit from "../../../../../../components/Form/Submit";
import { toast } from "react-toastify";
import associationActions from "../../../../../../store/actions/association";
import { hideModal } from "../../../../../../store/actions/modal";
import { AiOutlineSearch } from "react-icons/ai";
import { AcademyDto } from "../../../../../../types/academy.dto";
import { CurrentDto } from "../../../../../../types/current.dto";
import DinamicField from "../../../../../../components/Form/DinamicField";
import { OrganizationDto } from "../../../../../../types/organization.dto";
import { SuscriptionPrice, SuscriptionText } from "../../style";
import academyActions from "../../../../../../store/actions/academies";
import { ToggleButtonWrapper, ToggleInput, ToggleSlider } from "./style";
import Input from "../../../../../../components/Form/Input";
import { StateDto } from "../../../../../../types/states.dto";
import { PlanDto } from "../../../../../../types/plan.dto";
import { deletePlan, updatePlan } from "../../../../../../store/actions/plan";

const Component = ({
  currentPlan,
  current,
  updateAcademyStates,
  modalName,
  updatePlanStates,
  deletePlanStates,
}: {
  currentPlan: PlanDto;
  current: CurrentDto;
  updateAcademyStates: StateDto;
  modalName: string;
  updatePlanStates: StateDto;
  deletePlanStates: StateDto;
}) => {
  const [formSubmmited, setFormSubmmited] = useState(false);
  const [formActions, setFormActions] = useState<{ resetForm: () => void }>();
  const dispatch = useDispatch();

  const onSubmit = ({ values, actions }) => {
    if (values.monetizationStatus) {
      dispatch(
        updatePlan({
          unitPrice: values.unitPrice,
          currencyId: "ARS",
          type: "SUBSCRIPTION",
          academy: current.id,
        })
      );
    } else {
      dispatch(deletePlan({ _id: currentPlan._id }));
    }
    setFormActions(actions);
  };

  useEffect(() => {
    if (updatePlanStates.success) {
      dispatch(hideModal());
    }
  }, [updatePlanStates]);

  useEffect(() => {
    if (deletePlanStates.success) {
      dispatch(hideModal());
    }
  }, [deletePlanStates]);

  useEffect(() => {
    if (
      updateAcademyStates.success &&
      modalName === "edit-plan-modal-academy"
    ) {
      toast.success("👌🏼 Plan editado");

      setTimeout(() => {
        dispatch(academyActions.resetUpdate());
        dispatch(hideModal());
        formActions?.resetForm();
      }, 1000);
    }
  }, [updateAcademyStates]);
  return (
    <Modal name="edit-plan-modal-academy" title={`Editar plan de monetización`}>
      <>{console.log("yyyy", new Date(currentPlan.validFrom).valueOf())}</>
      <Formik
        initialValues={{
          ...initialValues,
          ...(currentPlan && {
            monetizationStatus:
              !currentPlan.validUntil && currentPlan.validFrom,
            unitPrice: currentPlan.unitPrice,
          }),
        }}
        onSubmit={(values, actions) => {
          if (onSubmit) onSubmit({ values, actions });
        }}
        validateOnChange={formSubmmited}
        validateOnBlur={false}
        validationSchema={schema}
        enableReinitialize
      >
        {({
          touched,
          errors,
          values,
          handleChange,
          handleBlur,
          handleSubmit,
          resetForm,
          setFieldValue,
          isSubmitting,
        }) => {
          return (
            <form
              className="theme-form"
              onSubmit={(event) => {
                setFormSubmmited(true);
                handleSubmit(event);
              }}
              id="invite-academy-modal-form"
            >
              <Grid.Row style={{ alignItems: "center" }}>
                <Grid.Col>
                  <FlexContainer align="center" gap="6px">
                    <SuscriptionText size={14}>free</SuscriptionText>
                    <ToggleButtonWrapper>
                      <ToggleInput
                        value={values["monetizationStatus"]}
                        onChange={() =>
                          setFieldValue(
                            "monetizationStatus",
                            !values["monetizationStatus"]
                          )
                        }
                        checked={values["monetizationStatus"]}
                        type="checkbox"
                      ></ToggleInput>
                      <ToggleSlider></ToggleSlider>
                    </ToggleButtonWrapper>
                    <SuscriptionText size={14}>paid</SuscriptionText>
                  </FlexContainer>
                </Grid.Col>
                <Grid.Col>
                  <SuscriptionText size={12}>
                    (Una vez hecho el cambio, este tendra efecto en el proximo
                    mes)
                  </SuscriptionText>
                </Grid.Col>
              </Grid.Row>
              <Separator size={12}></Separator>
              <Grid.Row>
                <Grid.Col>
                  <SuscriptionText size={14}>
                    Editar Pago mensual para el acceso a mi Academia
                  </SuscriptionText>
                  <Separator size={10}></Separator>
                  <FlexContainer
                    gap="7px"
                    align="center"
                    justify="center"
                    wrap="wrap"
                  >
                    <Input
                      name="unitPrice"
                      error={errors.unitPrice}
                      touched={touched.unitPrice}
                      value={values.unitPrice}
                      type="number"
                      placeholder="Ingresa monto"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      options={{
                        marginBottom: 0,
                        skin: "base",
                        before: (
                          <span
                            style={{
                              display: "inline-block",
                              paddingLeft: "10px",
                            }}
                          >
                            ARS$
                          </span>
                        ),
                      }}
                    />
                    <SuscriptionText size={10}>(por mes)</SuscriptionText>
                  </FlexContainer>
                  <Separator size={14}></Separator>
                </Grid.Col>
              </Grid.Row>
              <Grid.Row>
                <Grid.Col>
                  <Center gap={"70px"}>
                    <Submit
                      isSubmmiting={isSubmitting}
                      form="invite-academy-modal-form"
                      color="Primary"
                      options={{
                        type: "filled",
                        skin: "primary",
                        size: "lg",
                        marginBottom: "0px",
                      }}
                    >
                      Confirmar
                    </Submit>
                    <Button
                      onClick={resetForm}
                      type="button"
                      options={{
                        type: "filled",
                        skin: "danger",
                        size: "lg",
                        marginBottom: "0px",
                      }}
                      style={{ marginLeft: "10px" }}
                    >
                      Deshacer
                    </Button>
                  </Center>
                </Grid.Col>
              </Grid.Row>
            </form>
          );
        }}
      </Formik>
    </Modal>
  );
};

const states = ({
  associationStore,
  academyStore,
  currentStore,
  organizationStore,
  modalStore,
  planStore,
}) => {
  const { states: updateAcademyStates } = academyStore.update;
  const { data: current } = currentStore;
  const { visibleModal: modalName } = modalStore;
  const { states: updatePlanStates } = planStore.update;
  const { states: deletePlanStates } = planStore.delete;
  return {
    current,
    updateAcademyStates,
    modalName,
    updatePlanStates,
    deletePlanStates,
  };
};

export default connect(states)(Component);
